import { takeEvery, put } from 'redux-saga/effects';
import {
  checkVersionForMaintenance,
  setCurrentAppVersion
} from 'store/actions';
import { getWithToken } from 'api/network';

// ToDo: move to maintenanceSaga
export function* versionCheckForMaintenanceSaga() {
  yield takeEvery(checkVersionForMaintenance, function* () { 
    try {
      const response = yield getWithToken(`/api/ping/version`);
      const serverVersion = yield response.text();
      // Client version updates only after user hits F5. So after deployment serverVersion is always newer then clientVersion
      yield put(setCurrentAppVersion(serverVersion));
    }
    catch (error) {
      console.log(error)
      yield put(setCurrentAppVersion(null));
    }
  });
}